/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import {Link} from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import {Toaster} from "react-hot-toast";
import RateContext from "../../Context/RateContext";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import UpdateSchoolRate from "../../Components/Settings/ChargeRate/UpdateSchoolRate";
import AddChargeType from "../../Components/Settings/ChargeRate/AddChargeType";
import ChargeRatesTable from "../../Components/Common/Settings/ChargeRates/ChargeRatesTable";
import UpdateChargeRate from "../../Components/Settings/ChargeRate/UpdateChargeRate";
import AddChargeRate from "../../Components/Settings/ChargeRate/AddChargeRate";
import UpdateCanteenDepositRange from "../../Components/Settings/ChargeRate/UpdateCanteenDepositRange";
import UpdateCommissionPercentage from "../../Components/Settings/ChargeRate/UpdateCommissionPercentage";

function ChargeRatesPage() {

    const {rateList, getRateList, schoolRates, getSchoolRates, depositRates, getDepositRates, commissionPercentages, getCommissionPercentages, loading} = useContext(RateContext);
    const {getTypeList} = useContext(RateContext);

    const refreshData = () =>{
        getRateList();
        getSchoolRates();
        getTypeList();
        getDepositRates();
        getCommissionPercentages();
    }

    useEffect(() => {
        getSchoolRates();
        getRateList();
        getDepositRates();
        getCommissionPercentages();
    }, []);

    const [modal, setModal] = useStateCallback(false);

    const handleUpdate=(e,item)=>{
        setModal(false, ()=>setModal(<UpdateChargeRate rateID={item.rate_id} g={getRateList} isOpen={true} rate={item.rate} type={item.type}/>))
    }

    const handleUpdate2=(e,item)=>{
        setModal(false, ()=>setModal(<UpdateSchoolRate rateID={item.rate_id} g={getSchoolRates} isOpen={true} rate={item.rate} type={item.type}/>))
    }

    const handleUpdate3=(e,item)=>{
        setModal(false, ()=>setModal(<UpdateCanteenDepositRange rangeID={item.range_id} g={getDepositRates} isOpen={true} minAmount={item.min_amount} maxAmount={item.max_amount} charge={item.charge_rate}/>))
    }

    const handleUpdate4=(e,item)=>{
        setModal(false, ()=>setModal(<UpdateCommissionPercentage rateID={item.rate_id} g={getCommissionPercentages} isOpen={true} rate={item.rate}/>))
    }

    
    const handleAdd=(e,item)=>{
        setModal(false, ()=>setModal(<AddChargeType g={getTypeList} isOpen={true}/>))
    }

    return (
        <AppContainer title="Charge Rates">
            <Toaster position="top-center" reverseOrder={false} />
            {modal}
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="pl-20" style={{float: "right"}}>
                        <button type="button" onClick={handleAdd} className="btn-fill-lmd radius-30 mb-5 text-light shadow-dodger-blue bg-dodger-blue">
                            <i className="fa-solid fa-plus" /> Add Charge Type
                        </button>  
                    </div>
                </div>

                <div className="col-lg-4">
                    <AddChargeRate />
                </div>

                <div className="col-lg-8">
                    <div className="card custom-card" style={{borderRadius: "10px"}}>
                        <div className="card-body map-card">
                            <div class="heading-layout1 mg-b-25">
                                <TableHeader
                                title="Charge Rates"
                                subtitle="List of all the charge rates"
                                />
                                <div class="dropdown">
                                <Link class="dropdown-toggle"  role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                                </div>
                                </div>
                            </div>
                                        
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                <Row>
                                <Col sm={12}>
                                <Nav variant="pills" className="flex-row mb-1">
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="first">
                                        Default Rates{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="second">
                                    School Rates{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="third">
                                    Canteen Deposit Charges{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="fourth">
                                    Vendor Commission Percentages{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                </Nav>
                            </Col>

                            <Col sm={12}>
                                <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                            <Loader /> 
                                        ) : (
                                        <ChargeRatesTable rateList={rateList} handleUpdate={handleUpdate} ratesType="default"/>
                                        )}
                            
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="second">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <ChargeRatesTable rateList={schoolRates} handleUpdate={handleUpdate2} ratesType="school"/>
                                        )}
                                    </div>

                                </Tab.Pane>
                                 <Tab.Pane eventKey="third">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <table className="table display data-table text-nowrap">
                                                    <thead>
                                                    <tr>
                                                        <th>Range</th>
                                                        <th>Deposit Charge</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(depositRates) && depositRates.map((item, index) => (
                                                            <tr key={index}>
                                                            <td>UGX. {item.min_amount} - UGX. {item.max_amount}</td>
                                                            <td>{item.charge_rate}</td>
                                                                <td>
                                                                    <div className="dropdown">
                                                                        <Link
                                                                        to="#"
                                                                        className="dropdown-toggle"
                                                                        data-toggle="dropdown"
                                                                        aria-expanded="false">
                                                                        <span className="flaticon-more-button-of-three-dots"></span>
                                                                        </Link>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link
                                                                            className="dropdown-item"
                                                                            to="#"
                                                                            onClick={(e) => handleUpdate3(e,item)}>
                                                                            <i className="far fa-edit mr-1" style={{color:"orange"}}></i>
                                                                            Edit Range
                                                                        </Link>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                        
                                                        )}
                                                        {depositRates === "404" && (<tr>
                                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                                No deposit charge rates registered yet.
                                                            </td>
                                                        </tr>)}
                                                    </tbody>
                                                    </table>
                                        )}
                                    </div>

                                </Tab.Pane>
                                <Tab.Pane eventKey="fourth">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <table className="table display data-table text-nowrap">
                                                    <thead>
                                                    <tr>
                                                        <th>No.</th>
                                                        <th>Vendor Name</th>
                                                        <th>Commission Percentage (%)</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(commissionPercentages) && commissionPercentages.map((item, index) => (
                                                            <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.vendor}</td>
                                                            <td>{item.rate}</td>
                                                                <td>
                                                                    <div className="dropdown">
                                                                        <Link
                                                                        to="#"
                                                                        className="dropdown-toggle"
                                                                        data-toggle="dropdown"
                                                                        aria-expanded="false">
                                                                        <span className="flaticon-more-button-of-three-dots"></span>
                                                                        </Link>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link
                                                                            className="dropdown-item"
                                                                            to="#"
                                                                            onClick={(e) => handleUpdate4(e,item)}>
                                                                            <i className="far fa-edit mr-1" style={{color:"orange"}}></i>
                                                                            Edit Percentage
                                                                        </Link>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                        
                                                        )}
                                                        {commissionPercentages === "404" && (<tr>
                                                            <td colSpan="4" style={{ textAlign: "center" }}>
                                                                No vendor commission percentages registered yet.
                                                            </td>
                                                        </tr>)}
                                                    </tbody>
                                                    </table>
                                        )}
                                    </div>

                                </Tab.Pane>
                                </Tab.Content>
                            </Col>
                            </Row>
                            </Tab.Container>                
                                                        
                        </div>
                    </div>
                </div>
            </div>
        </AppContainer>
    );
}

export default ChargeRatesPage;
